/* @flow */
import ClickEventTrigger from 'components/ClickEventTrigger.jsx';
import React from 'react';

const TabPanel = React.createClass({
  propTypes: {
    title: React.PropTypes.element.isRequired,
    children: React.PropTypes.node,
    className: React.PropTypes.string,
    hidden: React.PropTypes.bool,
    eventElementName: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      inline: false,
      disabled: false,
      hidden: false,
    };
  },

  render() {
    return (
      <ClickEventTrigger eventElementName={this.props.eventElementName}>
        <div className={this.props.className}>
          {this.props.children}
        </div>
      </ClickEventTrigger>
    );
  },
});

export default TabPanel;



// WEBPACK FOOTER //
// ./src/components/TabPanel.jsx